import * as yup from "yup";

export const ShippingMethodSchema = yup.object().shape({
	shippingMethod: yup.string().required("Please select a shipping method"),
});
